import React from 'react';
import { useTranslation } from 'react-i18next';
import { StyledVoidView } from '../styled/StyledVoidView';

export const Void = () => {
  // necesita un elemento vacio
  const { t } = useTranslation();
  return (<StyledVoidView>{t('load.view')}</StyledVoidView>);
};
